import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMode } from "./context/modeContext";

function ModeGate({ mode }) {
  const { setMode } = useMode();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMode(mode);

    // remove /public or /private from URL
    const newPath = location.pathname.replace(`/${mode}`, "");

    navigate(newPath || "/", { replace: true });
  }, [mode]);

  return null;
}

export default ModeGate;